import { useTranslation } from 'react-i18next';

import { CalendarIcon } from 'src/components/Icons/icons';
import { OrganizationModuleType } from 'src/domain/organization';
import { ModuleSettingsScreen } from '../components/ModuleSettingsScreen';

export const CalendarSettings = () => {
    const { t } = useTranslation();

    return (
        <ModuleSettingsScreen
            basePath="/app/calendar"
            icon={CalendarIcon}
            moduleType={OrganizationModuleType.calendar}
            moduleName={t('modules.calendar.navLabel')}
            memberDescription={t(
                'modules.calendar.members.settingsDescription',
            )}
        />
    );
};
